"use client";

import { PortableText } from "next-sanity";
import { richTextComponent } from "@/sanity/sanityPortableText";
import Image from "@/helpers/Image";
import {
  PageEcommerceSchema,
  PageEcommerceRuleItem,
} from "@/sanity/pages/PageEcommerceTemplate";
import bg from "@/public/ecommerce/rulesbg.png";

function RuleCard({ item }: { item: PageEcommerceRuleItem }) {
  return (
    <div className="flex-1 bg-white border border-black/10 rounded-[0.25rem] p-[2rem] flex items-center gap-[2.75rem] min-w-0">
      <div className="bg-[#103037] shrink-0 w-[7.25rem] rounded-[0.25rem] flex items-center justify-center">
        {item.icon && (
          <Image src={item.icon} alt="" className="!w-full object-contain" />
        )}
      </div>
      <div className="flex flex-col min-w-0">
        <p className="mb-0 font-medium text-[2rem] leading-[1.4] tracking-[-0.1rem] text-black">
          {item.title}
        </p>
        <p className="mb-0 font-medium text-[2rem] leading-[1.4] tracking-[-0.1rem] text-[#666]">
          {item.subtitle}
        </p>
      </div>
    </div>
  );
}

export default function RulesSection({ data }: { data: PageEcommerceSchema }) {
  if (!data.rulesTitle && !data.rulesItems?.length) return null;

  const items = data.rulesItems ?? [];

  return (
    <section className="w-full bg-white pb-[7rem] lg:pb-[28rem] relative">
      <Image
        src={bg}
        alt=""
        className="hidden lg:block absolute z-0 left-0 bottom-0 object-cover w-full"
      />
      <div className="relative z-[1] mx-auto w-[min(170rem,100%)] px-[4rem] flex flex-col items-center gap-[4rem] lg:gap-[8rem]">
        {/* Header */}
        <div className="flex flex-col items-center gap-[2rem] text-center">
          {data.rulesChip && (
            <p className="mb-0 font-blacker italic text-[2rem] leading-[1.5] text-black">
              {data.rulesChip}
            </p>
          )}
          {data.rulesTitle && (
            <div className="richtext richtext-center prose-headings:mb-[2rem] prose-headings:font-medium prose-headings:text-[5rem] lg:prose-headings:text-[6rem] prose-headings:leading-[1.15] prose-headings:tracking-[-0.3rem] prose-headings:text-black">
              <PortableText
                value={data.rulesTitle}
                components={richTextComponent}
              />
            </div>
          )}
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[2rem] w-full lg:max-w-[125rem]">
          {items.map((item, i) => (
            <RuleCard key={item._key ?? i} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}
